import React, {Component} from 'react';
import InputWrap from "./InputWrap";
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";

class Toggle extends Component {
    constructor(props) {
        super(props);

        let checked = false;
        const {input} = props;

        if (input && (input.checked || input.value === 1 || input.value === true)) {
            checked = true;
        } else {
            if (props.defaultValue && (input && (input.value === 1 || input.value === ''))) {
                checked = true;
            } else {
                checked = false;
            }
        }

        this.state = {
            focused: false,
            checked: checked
        };

        this._handleBlur = this._handleBlur.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
        this._handleChange = this._handleChange.bind(this);
    }

    _handleFocus(e) {
        this.setState({
            focused: true
        });

        if (this.props.input && this.props.input.onFocus) {
            this.props.input.onFocus(e)
        }
    }

    _handleBlur(e) {
        this.setState({
            focused: false
        });

        if (this.props.input && this.props.input.onBlur) {
            this.props.input.onBlur(e)
        }
    }

    _handleChange(e) {
        e.persist();

        this.setState((prevState) => ({
            checked: !prevState.checked
        }), () => {
            if (this.props.input && this.props.input.onChange) {
                if (this.props.customClick) {
                    return this.props.input.onChange(this.state.checked);
                }

                return this.props.input.onChange(e, this.state.checked);
            }
        });
    }

    render() {
        const {id, placeholder, input, disabled, customClick} = this.props;
        const {focused} = this.state;
        const {checked} = this.state;

        const inputWrapProps = {
            ...this.props,
            focused: focused,
        };

        let inputProps = {
            ...this.props,
            checked: checked
        };

        if (input) {
            inputProps = {
                name:id,
                ...input,
                checked: checked
            }
        }

        if (!customClick) {
            return (
                <InputWrap {...inputWrapProps}>
                    <label htmlFor={id}>
                        <span className={classNamesPrefixed({"toggle": true, "toggle--on": !!checked,})}>
                            <span className={classNamesPrefixed({"toggler": true, "toggler--on": !!checked})}/>
                        </span>
                        <input
                            {...inputProps}
                            type={"checkbox"}
                            id={id}
                            name={inputProps.name || id}
                            placeholder={placeholder}
                            onChange={this._handleChange}
                            onFocus={this._handleFocus}
                            onBlur={this._handleBlur}
                            disabled={disabled}

                        />
                    </label>
                </InputWrap>
            );
        }

        return (
            <InputWrap {...inputWrapProps}>
                <div onClick={(event) => {
                    event.stopPropagation();
                    this._handleChange(event);
                }}>
                    <span className={classNamesPrefixed({"toggle": true, "toggle--on": !!checked,})}>
                        <span className={classNamesPrefixed({"toggler": true, "toggler--on": !!checked})}/>
                    </span>
                    <input
                        {...inputProps}
                        type={"checkbox"}
                        id={id}
                        name={input.name || id}
                        placeholder={placeholder}
                        disabled={disabled}

                    />
                </div>
            </InputWrap>
        );
    };
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/Toggle.js